import { generaLivello } from "./utility.js";
export default function quintoLivello(k) {
    k.scene("quintoLivello", () => {
        const LIVELLO = [
            "",
            "",
            "      $              $   ",
            "   $   ==              ==",
            "  =             $     ",
            "   ==         H=====",
            "      $        ^    $",
            "    ====        =====        ",
            "           =        ",
            " @       .       ^     =      > ",
            " =======================",
        ];
        generaLivello(k, LIVELLO, "ultimoLivello");
    });
}